import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["tip", "aria-label", "aria-busy"];
const _hoisted_2 = {
    key: 0,
    class: "rc-loader rc-loader-xs rc-noMargin"
};
const _hoisted_3 = ["innerHTML"];
import { computed, onMounted, ref } from "vue";
import { i18n } from "@/core/i18n";
import { useDisplay } from "@/common/composables/display";
import SvgIcon from "@/common/components/SvgIcon.vue";
import { useOpenHelpdeskArticleListener, useOpenHelpdeskConversationListener, useToggleIntercomListener } from "@/common/composables/custom-events";
import { useIntercomMessenger } from "@/experiences/intercom/composables/use-intercom-messenger";
import RecDialog from "@/common/components/RecDialog.vue";
import RecCardTitle from "@/common/components/RecCardTitle.vue";
import RecCardContent from "@/common/components/RecCardContent.vue";
import RecCardFooter from "@/common/components/RecCardFooter.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'IntercomBeaconView',
    props: {
        isLiveActivity: { type: Boolean, default: false },
        studyAlias: { default: "" },
        activityAlias: { default: "" },
        primaryColor: { default: "" },
        secondaryColor: { default: "" },
        helpdeskOnly: { type: Boolean, default: false },
        isModerator: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        // isOpen/isLoading and the boot logic live in this shared singleton, since every
        // <intercom-beacon> trigger on a page controls the one same real Messenger.
        const { isOpen, isLoading, toggleMessenger, showMessengerArticle, showMessengerConversation, bootIfUsedThisSession } = useIntercomMessenger();
        // The boot error dialog stays per-instance: if it were shared, every mounted trigger would pop its
        // own copy of the dialog at once whenever any one of them failed to boot.
        const hasBootError = ref(false);
        const { isCompact: isMobile } = useDisplay();
        const helptext = computed(() => (isOpen.value ? i18n.t("Close Help") : i18n.t("Help")));
        const helperrortext = computed(() => (props.isModerator ? i18n.t("If you still can't connect, contact {0}", ['<a href="mailto:helpdesk@recollective.com">helpdesk@recollective.com</a>'])
            : i18n.t("If you still can't connect, contact the study moderator")));
        const bootContext = computed(() => ({
            isLiveActivity: props.isLiveActivity,
            studyAlias: props.studyAlias,
            activityAlias: props.activityAlias,
            primaryColor: props.primaryColor,
            secondaryColor: props.secondaryColor,
            helpdeskOnly: props.helpdeskOnly
        }));
        const buttonClick = async () => {
            if (!(await toggleMessenger(bootContext.value))) {
                hasBootError.value = true;
            }
        };
        const retryBoot = () => {
            hasBootError.value = false;
            buttonClick();
        };
        useOpenHelpdeskArticleListener(async ({ articleId }) => {
            if (!(await showMessengerArticle(bootContext.value, articleId))) {
                hasBootError.value = true;
            }
        });
        useOpenHelpdeskConversationListener(async ({ message }) => {
            if (!(await showMessengerConversation(bootContext.value, message))) {
                hasBootError.value = true;
            }
        });
        useToggleIntercomListener(() => {
            buttonClick();
        });
        onMounted(() => {
            bootIfUsedThisSession(bootContext.value);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: _normalizeClass(["rc-supportBeacon rc-fixedNavIcon", { open: _unref(isOpen), closed: !_unref(isOpen) }]),
                    onClick: buttonClick
                }, [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                        _createElementVNode("button", {
                            class: _normalizeClass(["rc-supportBeaconButton", { open: _unref(isOpen) }]),
                            tip: helptext.value,
                            tabindex: "0",
                            "aria-label": helptext.value,
                            "aria-busy": _unref(isLoading)
                        }, [
                            (_unref(isLoading))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                    _createVNode(SvgIcon, { icon: "loader-spin" })
                                ]))
                                : (_unref(isMobile))
                                    ? (_openBlock(), _createBlock(SvgIcon, {
                                        key: 1,
                                        icon: "icon-help"
                                    }))
                                    : (_openBlock(), _createBlock(SvgIcon, {
                                        key: 2,
                                        icon: "icon-question-mark"
                                    }))
                        ], 10, _hoisted_1)
                    ])
                ], 2),
                _createVNode(RecDialog, {
                    modelValue: hasBootError.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((hasBootError).value = $event)),
                    size: "small"
                }, {
                    default: _withCtx(() => [
                        _createVNode(RecCardTitle, null, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("Can't connect to Help")), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(RecCardContent, null, {
                            default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("Help is temporarily unavailable. Try again.")), 1),
                                _createElementVNode("p", { innerHTML: helperrortext.value }, null, 8, _hoisted_3)
                            ]),
                            _: 1
                        }),
                        _createVNode(RecCardFooter, null, {
                            default: _withCtx(() => [
                                _createElementVNode("button", {
                                    class: "btn btn-primary",
                                    onClick: retryBoot
                                }, _toDisplayString(_ctx.$t("Try Again")), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
